/** Vai trò được xem toàn bộ số liệu cửa hàng. */
export const PRIVILEGED_ROLES = ['admin', 'manager', 'accountant'];

export type HomeDashboard = 'sales' | 'main';

/**
 * Quyết định dashboard ở trang chủ `/`, khớp policy backend.
 *
 * - admin/quản lý/kế toán luôn thấy dashboard chính — kể cả khi tài khoản gắn nhân viên.
 * - Dashboard bán hàng: Reports::SalesDashboardPolicy chỉ cho vai trò `sales`, và cần
 *   nhân viên liên kết để lọc số liệu.
 * - Dashboard chính: cần quyền `reports/dashboard:index`.
 * - Còn lại trả `null` → không có trang Tổng quan, điều hướng sang menu được phép.
 *
 * Chỉ gọi khi đã biết chắc danh sách vai trò: vai trò chưa tải xong mà đem ra quyết
 * định thì admin sẽ bị xử như user không có quyền vì lúc đó `roles` rỗng.
 */
export const resolveHomeDashboard = (
  roleNames: string[] | null | undefined,
  employeeId: number | null | undefined,
  canViewMainDashboard = false,
): HomeDashboard | null => {
  const names = (roleNames ?? []).map((name) => String(name).toLowerCase());

  if (names.some((name) => PRIVILEGED_ROLES.includes(name))) return 'main';
  if (names.includes('sales') && employeeId) return 'sales';
  if (canViewMainDashboard) return 'main';

  return null;
};
